import * as React from "react";
const SvgFiRrSwimmingPool = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-swimming-pool_svg__a)">
      <path
        fill="#062147"
        d="M6 18a1 1 0 0 0 1-1v-2h10v2a1 1 0 0 0 2 0V4.996c0-1.639 1.327-2.978 2.99-2.998L22 2a1 1 0 0 0 0-2c-.008 0-.014.004-.02.004v-.008a5.01 5.01 0 0 0-4.98 5V7H7V4.996c0-1.639 1.327-2.978 2.99-2.998L10 2a1 1 0 0 0 0-2c-.008 0-.014.004-.02.004v-.008a5.01 5.01 0 0 0-4.98 5V17a1 1 0 0 0 1 1m1-9h10v4H7zm16.668 13.978A4 4 0 0 1 21 24a4.38 4.38 0 0 1-3-1.225A4.38 4.38 0 0 1 15 24a4.38 4.38 0 0 1-3-1.225A4.38 4.38 0 0 1 9 24a4.38 4.38 0 0 1-3-1.225A4.38 4.38 0 0 1 3 24a3.98 3.98 0 0 1-2.668-1.023A1 1 0 1 1 1.67 21.49c.366.33.84.51 1.332.51.89 0 1.793-.585 2.057-1.333a1 1 0 0 1 1.886 0C7.208 21.415 8.112 22 9.001 22c.89 0 1.793-.585 2.057-1.333a1 1 0 0 1 1.886 0c.264.748 1.168 1.333 2.057 1.333.89 0 1.793-.585 2.057-1.333a1 1 0 0 1 1.886 0c.264.748 1.168 1.333 2.057 1.333a2 2 0 0 0 1.333-.51 1 1 0 1 1 1.336 1.487z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-swimming-pool_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSwimmingPool;
